export default class BasePDFDefinitionCreator {
    createDocDefinition(pdfData, pdfPrintParameters) {}
};



// WEBPACK FOOTER //
// ./web/js/pdf/BasePDFDefinitionCreator.js